import { render } from "./GroProgress.vue?vue&type=template&id=89996ad0"
import script from "./GroProgress.vue?vue&type=script&lang=js"
export * from "./GroProgress.vue?vue&type=script&lang=js"

import "./GroProgress.vue?vue&type=style&index=0&id=89996ad0&lang=css"
script.render = render

export default script